module.exports = __webpack_public_path__ + "img/overheads-rental-cost.12fec2f2.svg";